// src/components/common/Loading.jsx
import React from "react";
import { Center, Spinner } from "@chakra-ui/react";

/**
 * @param {boolean} fullScreen — if true, takes up the full viewport height
 * @param {string|number} height — optional custom container height (when not fullScreen)
 */
const Loading = ({ fullScreen = false, height }) => {
  const containerHeight = fullScreen
    ? "100vh"
    : height || "100%";

  return (
    <Center
      w="100%"
      h={containerHeight}
    >
      <Spinner size="xl" />
    </Center>
  );
};

export default Loading;
